import { ApplicationDetailsPageActions } from "../redux";
import { useDispatch } from "react-redux";
import { useSelectorTyped } from "../../../../common/redux/store";

export function useApplicationStatusController() {
  const dispatch = useDispatch();
  const isApplicationStatusInEditMode = useSelectorTyped((state) => state.applicationDetailsPage.isApplicationStatusInEditMode);

  const applicationBasicInfo = useSelectorTyped((state) => state.applicationDetailsPage.applicationBasicInfoPEV.value!);

  const onClickEditButton = () => {
    dispatch(ApplicationDetailsPageActions.updateApplicationStatusEditState(true));
  };

  const isUserAuthorizedToEditApplicationStatus = applicationBasicInfo.isStatusEditable;

  return {
    onClickEditButton,
    isApplicationStatusInEditMode,
    applicationStatus: applicationBasicInfo.status,
    isUserAuthorizedToEditApplicationStatus,
  };
}
